<div class="line-decorator"></div>
<div class="form-group">
  <label  class="flash-label">Nombre y Apellido</label>
  <input
    [(ngModel)]="flashPaymentService.controller.name"
    type="text"
    class="form-control"
    name="name"
  />
</div>
<div class="form-group">
  <label for="cardNumberString" class="flash-label"
  >N&uacute;mero de Tarjeta:</label
  >
  <div class="card-number-with-image">
    <input
      [(ngModel)]="flashPaymentService.controller.cardNumberString"
      type="text"
      class="form-control"
      name="cardNumberString"
      id="cardNumberString"
      maxlength="18"
      [appOnlyNumber]="true"
      (change)="
              flashPaymentService.isValidCreditCardNumber(
                flashPaymentService.controller.cardNumberString
              )
            "
      autocomplete="off"
    />

    <img
      class="card-img-small input-image-fix"
      src="../../../../../assets/images/Payment Method/Visa.png"
      alt=""
      *ngIf="flashPaymentService.controller.cardType === 'VISA'"
    />
    <img
      class="card-img-small input-image-fix"
      src="../../../../../assets/images/Payment Method/Mastercard.png"
      alt=""
      *ngIf="flashPaymentService.controller.cardType === 'MASTER CARD'"
    />
    <img
      class="card-img-small input-image-fix"
      src="../../../../../assets/images/Payment Method/Amex.png"
      alt=""
      *ngIf="flashPaymentService.controller.cardType === 'AMERICAN EXPRESS'"
    />
    <img
      class="card-img-small input-image-fix"
      src="../../../../../assets/images/Payment Method/ath.png"
      alt=""
      *ngIf="flashPaymentService.controller.cardType === 'ATH'"
    />
  </div>


  <span
    class="card-error"
    *ngIf="
              !flashPaymentService.controller.isValidCard &&
              flashPaymentService.controller.cardNumberString !== ''
            "
  >
            Tarjeta Inválida
          </span>
  <span
    class="card-error"
    *ngIf="flashPaymentService.controller.isTheCardNumberEmpty"
  >
            Este campo es obligatorio
          </span>
</div>

<div class="row">
  <div class="col-lg">
    <div class="form-group">
      <label for="nombre" class="flash-label"
      >Fecha de Expiraci&oacute;n:</label
      >
      <div class="row">
        <div class="col-lg mb-4">
          <select
            class="form-control"
            [(ngModel)]="flashPaymentService.controller.expirationMonth"
            name="expirationMonth"
            (change)="flashPaymentService.changeExpirationMonth()"
          >
            <option [value]="''" disabled selected>mes</option>
            <option
              [value]="item"
              *ngFor="let item of flashPaymentService.controller.months"
            >
              {{ item }}
            </option>
          </select>

        </div>

        <div class="col-lg">
          <select
            class="form-control pb1"
            [(ngModel)]="flashPaymentService.controller.expirationYear"
            name="expirationYear"
            (change)="flashPaymentService.changeExpirationMonth()"
          >
            <option [value]="''" disabled selected>Año</option>
            <option
              [value]="item"
              *ngFor="let item of flashPaymentService.controller.years"
            >
              {{ item }}
            </option>
          </select>
        </div>



      </div>
      <span
        class="card-error"
        *ngIf="flashPaymentService.controller.cardIsExpired"
      >
                Tarjeta vencida, verifique información
              </span>
    </div>
  </div>
  <div class="col-lg">
    <div class="form-group" *ngIf="flashPaymentService.controller.paymentMethod != 'A'">
      <label for="nombre" class="flash-label">CCV:</label>
      <input
        [(ngModel)]="flashPaymentService.controller.ccv"
        type="password"
        class="form-control"
        name="ccv"
        autocomplete="off"
        (change)="flashPaymentService.ccvChanged()"
        [appOnlyNumber]="true"
        [maxlength]="flashPaymentService.controller.paymentMethod === 'X' ? 4 : 3"
      />

      <span
        class="card-error"
        *ngIf="flashPaymentService.controller.isTheCcvEmpty"
      >
                Este campo es obligatorio
              </span>
      <span
        class="card-error"
        *ngIf="flashPaymentService.controller.isTheCcvError"
      >
                CCV inv&aacute;lido, Intente nuevamente
              </span>
    </div>
  </div>
</div>

<div class="form-group">
  <div class="row">
    <div class="col-lg">
      <label for="nombre" class="flash-label adress">
        Direcci&oacute;n associada a mi tarjeta
      </label>
    </div>

    <div class="col-lg justify-content-end">
      <div class="form-check">
        <input
          [(ngModel)]="flashPaymentService.controller.useSavedInformation"
          class="form-check-input"
          type="checkbox"
          [value]="flashPaymentService.controller.useSavedInformation"
          id="useSavedInformation"
          name="useSavedInformation"
          (click)="flashPaymentService.autoFill()"
        />
        <label class="form-check-label" for="useSavedInformation">
          Utilizar direci&oacute;n asociada a
          <img
            class="check-image"
            src="../../../assets/images/icon_Claro.png"
            alt=""
          />
        </label>
      </div>
    </div>
  </div>

</div>

<div class="row">
  <div class="col-lg-6">
    <div class="form-group">
      <label for="nombre" class="flash-label"
      >C&oacute;digo postal:</label
      >
      <input
        [(ngModel)]="flashPaymentService.controller.PostalCode"
        type="text"
        class="form-control"
        id="PostalCode"
        name="PostalCode"
        (change)="flashPaymentService.zipCodeChanged()"
        appOnlyNumber="true"
      />

      <span class="card-error" *ngIf="!flashPaymentService.controller.isValidZip">
                Zip code invalido
              </span>
      <span
        class="card-error"
        *ngIf="flashPaymentService.controller.isEmptyZipCode"
      >
                Este campo es obligatorio
              </span>
    </div>
  </div>
</div>

<div class="form-check" *ngIf="flashPaymentService.controller.paymentMethod != 'A'">
  <input
    class="form-check-input"
    type="checkbox"
    id="canActivateTokenizationProcess"
    [(ngModel)]="flashPaymentService.controller.canActivateTokenizationProcess"
    class="form-check-input"
    type="checkbox"
    [value]="flashPaymentService.controller.canActivateTokenizationProcess"
    name="canActivateTokenizationProcess"
    (click)="flashPaymentService.activateTokenCard()"
  />
  <label
    class="form-check-label add-text"
    for="canActivateTokenizationProcess"
  >
    Guardar tarjeta para futuros pagos
  </label>
</div>

<div class="line-decorator"></div>
<div class="action-container">
  <button
    class="btn btn-danger action-btn"
    (click)="flashPaymentService.stepUpdate(1)"
  >
    Pagar
    {{ flashPaymentService.controller.operationAmount | currency }}
   
  </button>
</div>
